import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getPliReviewQueue, approvePli, rejectPli } from "../services/pliService";
import { downloadContractorDocument } from "../services/contractorsService";

const fmt = (d) => (d ? new Date(d).toLocaleDateString("en-GB") : "-");

const PliReviewQueue = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getPliReviewQueue();
      if (res.success) setRows(res.data || []);
      else toast.error(res.message || "Failed to load PLI review queue");
    } catch (e) {
      toast.error(e.message || "Failed to load PLI review queue");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const approve = async (row) => {
    setBusyId(row.id);
    try {
      const res = await approvePli(row.contractor_id, row.id);
      if (res.success) { toast.success("Certificate approved"); await load(); }
      else toast.error(res.message || "Approve failed");
    } catch (e) { toast.error(e.message || "Approve failed"); }
    finally { setBusyId(null); }
  };

  const download = async (row, e) => {
    e?.preventDefault();
    try {
      const res = await downloadContractorDocument(row.contractor_id, row.id);
      if (!res?.success) toast.error(res?.message || "Download failed");
    } catch (err) { toast.error(err.message || "Download failed"); }
  };

  const reject = async (row) => {
    const reason = window.prompt("Reason for rejecting this certificate:");
    if (!reason) return;
    setBusyId(row.id);
    try {
      const res = await rejectPli(row.contractor_id, row.id, reason);
      if (res.success) { toast.success("Certificate rejected — contractor notified"); await load(); }
      else toast.error(res.message || "Reject failed");
    } catch (e) { toast.error(e.message || "Reject failed"); }
    finally { setBusyId(null); }
  };

  return (
    <div style={{ padding: 24, fontFamily: "Arial, sans-serif" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 style={{ margin: 0 }}>PLI Review Queue</h2>
        <button onClick={load} style={{ padding: "6px 14px" }}>Refresh</button>
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 16 }}>
        <thead>
          <tr style={{ textAlign: "left", borderBottom: "2px solid #eee" }}>
            <th style={{ padding: 8 }}>Contractor</th>
            <th style={{ padding: 8 }}>Certificate</th>
            <th style={{ padding: 8 }}>Expiry</th>
            <th style={{ padding: 8 }}>Submitted</th>
            <th style={{ padding: 8 }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan={5} style={{ padding: 16 }}>Loading…</td></tr>
          ) : rows.length === 0 ? (
            <tr><td colSpan={5} style={{ padding: 16, color: "#888" }}>No certificates pending review.</td></tr>
          ) : (
            rows.map((r) => (
              <tr key={r.id} style={{ borderBottom: "1px solid #f0f0f0" }}>
                <td style={{ padding: 8 }}>
                  <a href={`/contractors/${r.contractor_id}`}>{r.contractor_name}</a>
                  <div style={{ color: "#888", fontSize: 12 }}>{r.contractor_ref}</div>
                </td>
                <td style={{ padding: 8 }}>
                  <a href="#download" onClick={(e) => download(r, e)}>{r.name || r.file}</a>
                </td>
                <td style={{ padding: 8 }}>{fmt(r.date_expiration)}</td>
                <td style={{ padding: 8 }}>{fmt(r.created_at)}</td>
                <td style={{ padding: 8 }}>
                  <button disabled={busyId === r.id} onClick={() => approve(r)}
                    style={{ padding: "6px 12px", marginRight: 8, background: "#1a9c4c", color: "#fff", border: "none", borderRadius: 4 }}>
                    Approve
                  </button>
                  <button disabled={busyId === r.id} onClick={() => reject(r)}
                    style={{ padding: "6px 12px", background: "#d33", color: "#fff", border: "none", borderRadius: 4 }}>
                    Reject
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PliReviewQueue;
